import { type Attrs, type DOMOutputSpec, type Node, type NodeSpec } from "prosemirror-model";

import { CELL_SPEC_ATTRS, DEFAULT_CELL_ID } from "@moment/prosemirror-utils";

// Block variant of code snippet for inline full preview
export const code_snippet_block: NodeSpec = {
	attrs: {
		...CELL_SPEC_ATTRS,
		url: { default: "" },
		owner: { default: "" },
		repo: { default: "" },
		refspec: { default: "" },
		filePath: { default: "" },
		startLine: { default: 0 },
		endLine: { default: null },
	},
	group: "block",
	atom: true,
	selectable: true,
	parseDOM: [
		{
			tag: "a[data-expanded='true']",
			getAttrs(node: string | HTMLElement) {
				if (typeof node === "string") {
					return {};
				}

				const href = node.getAttribute("href");
				if (
					typeof href !== "string" ||
					!href.includes("github.com/") ||
					!href.includes("/blob/")
				) {
					return false;
				}

				try {
					const m = href.match(
						/^https?:\/\/(?:www\.)?github\.com\/([^/\s]+)\/([^/\s]+)\/blob\/([^#]+)(?:#(.*))?$/
					);
					if (!m) {
						return false;
					}

					const owner = m[1] as string;
					const repo = m[2] as string;
					const refAndPath = m[3] as string;
					const hash = (m[4] as string) || "";
					const firstSlash = refAndPath.indexOf("/");
					if (firstSlash === -1) {
						return false;
					}

					const refspec = refAndPath.substring(0, firstSlash);
					const filePath = refAndPath.substring(firstSlash + 1);
					let startLine = 0;
					let endLine: number | null = null;
					const lineMatch = hash.match(/^L(\d+)(?:-L(\d+))?$/);
					if (lineMatch) {
						startLine = parseInt(lineMatch[1] as string, 10);
						endLine = lineMatch[2] ? parseInt(lineMatch[2] as string, 10) : null;
					}

					const expanded = true;
					const id = node.getAttribute("id") || DEFAULT_CELL_ID;

					const attrs: Attrs = {
						url: href,
						owner,
						repo,
						refspec,
						filePath,
						startLine,
						endLine,
						expanded,
						id,
					};
					return attrs;
				} catch {
					return false;
				}
			},
		},
	],
	toDOM(node: Node) {
		const attrs: Attrs = {
			"id": node.attrs["id"],
			"href": node.attrs["url"],
			"data-expanded": "true",
		};
		const dom: DOMOutputSpec = ["a", attrs];
		return dom;
	},
};
